__turbopack_context__.v({
  "avatar": "styles-module__XFxVGa__avatar",
  "info": "styles-module__XFxVGa__info",
  "nameRow": "styles-module__XFxVGa__nameRow",
  "row": "styles-module__XFxVGa__row",
  "username": "styles-module__XFxVGa__username",
  "verifiedBadge": "styles-module__XFxVGa__verifiedBadge",
});
